import { Device, Grid, Theme } from '@livecontrol/core-ui';
import { Obj } from '@livecontrol/core-utils';
import { Filters } from '@livecontrol/scheduler/components';
import { Scheduler } from '@livecontrol/scheduler/store';
import cx from 'classnames';
import type { HTMLAttributes, ReactElement } from 'react';
import styled from 'styled-components';
import { Sorting as SortFilter } from '../../../components';
import { Store } from '../../../store';
import type { Location} from '../types';
import { Sorting as Sorting_ } from '../types';

const ActionsBar = styled.div`
  width: 100%;
  flex-wrap: wrap;
  margin-bottom: 30px;
  margin-top: 6px;

  .search-input-section {
    min-width: 300px;
    margin-bottom: 10px;

    input {
      color: #0d1438;
      font-size: 12px;
      font-weight: 600;
    }
    div {
      background-color: transparent;
      border-color: #8798ad;
      color: #0d1438;
    }
  }

  input::-webkit-input-placeholder {
    /* Edge */
    color: #0d1438;
    font-size: 12px;
    font-weight: 600;
  }
  input::placeholder {
    color: #0d1438;
    font-size: 12px;
    font-weight: 600;
  }
`;

interface ActionsProps {
  onChangeKeyword: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onChangeLocation: (value?: Location | Location[]) => void;
  valueLocation: Location | undefined;
  onChangeDate: (v?: Filters.Period.Value) => void;
  onChangeSorting: (value: Sorting_) => void;
  valueSorting: Sorting_;
  valueKeyword: string | undefined;
  valueDate: Partial<{
      min: Date;
      max: Date;
  }> | undefined;
}

export const Actions = ({
  onChangeKeyword,
  valueKeyword,
  onChangeDate,
  onChangeSorting,
  valueSorting,
  valueDate,
  onChangeLocation,
  valueLocation,
  ...rest
}: ActionsProps & HTMLAttributes<HTMLDivElement>): ReactElement => {
  const viewport = Theme.useViewport();
  const size = Device.isMobile(viewport) ? undefined : 'lg';
  const today = new Date();

  const account = Store.Account.useAccount();
  const { locations } = Scheduler.Location.useLocations(account);

  const { keys } = Sorting_;

  const sortingAvailable = Obj.keys(keys).map((key) => ({
    key,
    label: keys[key]
  }));


  return (
    <ActionsBar className='d-flex align-items-center justify-content-xl-between flex-xl-row flex-column'>
      <div className='search-input-section'>
        <Filters.Keyword
            placeholder='Search'
            onChange={onChangeKeyword}
            value={valueKeyword}
            htmlSize={30}
            size={size}
            className='search-section'
          />
      </div>
      <Grid
        className={cx(
          'grid-flow-column',
          Device.isMobile(viewport) ? null : 'gap-8px',
          'justify-content-end'
        )}
        style={{ marginBottom: '10px' }}
        {...rest}
      >
        { locations &&  <Filters.Location onChange={onChangeLocation} value={{available: locations, selected: valueLocation}} size={size} />}
        <Filters.Period onChange={onChangeDate} value={valueDate} pickerProps={{maxDate: today}} size={size}/>
        <SortFilter value={{available: sortingAvailable, selected: valueSorting}} onChange={onChangeSorting} size={size} />
        {/* <Event size={size} />  */}
      </Grid>
    </ActionsBar>
  );
};
